import { combineReducers } from 'redux'

import { selectProductPackage } from '../productPackages'
import { selectUser } from '../users'
import { selectVehicle } from '../vehicles'
import applicationCoverageState from './coverageStateReducer'
import applicationState from './applicationStateReducer'

import createAllIdsReducer from '../entity/allIds'
import createByIdReducer from '../entity/byId'
import currentApplication from './currentApplicationReducer'
import paymentOptions from './paymentOptionsReducer'
import selectedTerms from './selectedTermsReducer'

export default combineReducers({
  byId: createByIdReducer('refi'),
  allIds: createAllIdsReducer('refi'),
  applicationCoverageState,
  applicationState,
  currentApplication,
  paymentOptions,
  selectedTerms,
})

export const selectRefi = (state, id) => {
  if (id) {
    return state.byId[id] || {}
  } else {
    return {}
  }
}

export const selectCurrentRefiVehicle = (state) => {
  return selectVehicle(state.vehicles, state.refis.currentApplication.vehicleId)
}

export const selectCurrentRefiUser = (state) => {
  return selectUser(state.users, state.refis.currentApplication.userId)
}

export const selectCurrentRefi = (state) => {
  return selectRefi(state.refis, state.refis.currentApplication.refiId)
}

export const selectCurrentTradeline = (state) => {
  const refi = selectCurrentRefi(state)
  const selectedTradelineIndex =
    state.refis.currentApplication.selectedTradelineIndex
  const tradeline = refi.open_tradelines.find(
    (t) => t.tradeline_index === selectedTradelineIndex
  )

  return tradeline
}

export const selectCurrentProductPackageId = (state) => {
  return state.refis.currentApplication.productPackageId
}

export const selectCurrentPackageProducts = (state) => {
  const productPackage = selectProductPackage(
    state.productPackages,
    state.refis.currentApplication.productPackageId
  )
  return productPackage.products || []
}

export const selectProducts = (state) => {
  if (!state.refis.currentApplication.rejectedCreditApplication) {
    const refi = selectCurrentRefi(state)
    return refi.products || []
  }

  return selectCurrentPackageProducts(state)
}

export const selectGapProduct = (state) => {
  const products = selectProducts(state)

  const gapProduct = products.find((p) => p.product_type === 'gap')
  return gapProduct
}

export const selectSelectedGapProduct = (state) => {
  const products = selectProducts(state)
  const selectedGapProduct = products.find(
    (p) => p.product_type === 'gap' && p.selected_option_id
  )

  return selectedGapProduct
}

export const selectSelectedVscProducts = (state) => {
  const products = selectProducts(state)
  const selectedVscProducts = products.filter(
    (p) => p.product_type === 'vsc' && p.selected_option_id
  )

  return selectedVscProducts
}

export const selectVscProducts = (state) => {
  const products = selectProducts(state)

  const vscProducts = products.filter((p) => p.product_type === 'vsc')
  return vscProducts
}

export const selectProductsSurcharges = (state) => {
  const products = selectProducts(state)
  const surcharges = (products || []).reduce((acc, product) => {
    product.options.forEach((option) => acc.push(...option.surcharges))
    return acc
  }, [])

  return surcharges
}

export const selectSelectableProducts = (state) => {
  const refi = selectCurrentRefi(state)
  if (!refi.id) return []

  return refi.selectableProducts || []
}

export const selectSelectedProducts = (state) => {
  const refi = selectCurrentRefi(state)
  if (!refi.id) return []

  return refi.selectedProducts || []
}

export * from './applicationStateReducer'
export * from './coverageStateReducer'
export * from './currentApplicationReducer'
export * from './paymentOptionsReducer'
export * from './selectedTermsReducer'
